import { useTranslation } from "react-i18next";
import { LeafBannerToast } from "../../../common/leaf/LeafBannerToast/LeafBannerToast";
import { IconAlert } from "../../../common/icons/IconAlert/IconAlert";
import defaultContent from "../../../content/earningsCalculator";
import "./EarningsCalculatorExceedMaxBanner.scss";
import { useAppSelector } from "../../../store";

export const EarningsCalculatorExceedMaxBanner = () => {
  const { t } = useTranslation(["earningsCalculator"]);
  const { Settings } = useAppSelector((state: any) => state.earningCalculator.ECComputedData);
  const { IsExceededMaxValue } = Settings;

  if (!IsExceededMaxValue) return <></>;

  return (
    <div className="earnings-exceed-max-banner">
      <LeafBannerToast theme="yellow" closeFunction={() => {}} show id="earningsCalculatorExceedMaxBanner">
        <section className="earningsExceedMaxBanner">
          <span className="earningsExceedMaxBanner__title">
            <div className="earningsExceedMaxBanner__icon">
              <IconAlert />
            </div>
            {`${t("toast.title", defaultContent.toast.title)}`}
          </span>
          <p className="earningsExceedMaxBanner__message">
            {`${t("toast.description", defaultContent.toast.description)}`}
          </p>
        </section>
      </LeafBannerToast>
    </div>
  );
};
